import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { Location } from '@angular/common';
import { PolicyDetailsService } from '../services/policydetails.service';
import { StepItem } from 'src/app/models/common/step-item';

@Component({
  selector: '',
  template: '',
})
export class PolicyDetailsStepFormHandlerComponent
  extends BaseStepFormComponent<PolicyDetailsService>
  implements OnInit
{
  protected getStepList(): StepItem[] {
    let stepList: StepItem[];
    let facetId = 'POLICYDETAILS';
    stepList = this.service.getStepList(this.service.policyFacets.data[facetId]);
    return stepList;
  }

  constructor(
    service: PolicyDetailsService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
    if (this.service.policyFacets != undefined) this.service.policyFacets = undefined;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.additionalInfo = this.service.responseIO.data.Entity.productId;
    if (this.service.responseIO.data.Entity.policyNum != null) {
      header.refNumber = this.service.responseIO.data.Entity.policyNum;
      header.title = 'Policy';
    } else if (this.service.responseIO.data.Entity.proposalNum != null) {
      header.refNumber = this.service.responseIO.data.Entity.proposalNum;
      header.title = 'Proposal';
    }
    header.moreOptionList = this.getMoreOptionList();
    return header;
  }
  protected getMoreOptionList(): any[] {
    let optionList: any[];
    optionList = [];
    return optionList;
  }
  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
      {
        id: 'search',
        link: '/search-policy-listing',
      },
      {
        id: 'Policy',
      },
    ];
  }

  protected preLoad() {
    this.loadCompanyFacets();
  }

  protected postProcess() {
    //  this.loadProductFacets();
  }

  protected postInit(): void {
    this.loadCompanyFacets();
  }

  protected loadCompanyFacets(): void {
    //TODO in product selection component clear out the productfacets on change of product.

    if (this.service.policyFacets == undefined) {
      this.service.getUIFacets().subscribe(
        (facets) => {
          this.service.policyFacets = [];
          this.service.policyFacets = JSON.parse(JSON.stringify(facets));
          this.postLoadCompanyFacets();
          console.log('Facets loaded successful.');
        },
        (error) => {
          console.log('Facets load failed.');
          console.log('Error:', error);
        }
      );
    }
  }

  protected but_DraftSave_click() {
    //on accept counter offer,need to save si signature..for that copy si signture records into policy
    super.but_DraftSave_click();
  }

  protected but_Accept_click() {
    let nextStepObj = this.stepList[this.selectedStep.index + 1];
    this.saveUpdatedModels(this.selectedStep, nextStepObj, undefined, 'but_Accept');
  }

  protected but_Complete_click() {}

  protected but_submitStatus_click() {}
  protected but_Submit_click() {
    //setting the current step itself as the next step since is the last step
    let nextStepObj = this.stepList[this.selectedStep.index + 1];
    this.saveUpdatedModels(this.selectedStep, nextStepObj, undefined, 'but_Submit');
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  protected postLoadCompanyFacets() {}
}
